// extracted by mini-css-extract-plugin
module.exports = {"applicationWrapper":"style__applicationWrapper___1OATQ"};